import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeLocationName'
})
export class RemoveLocationNamePipe implements PipeTransform {

  transform(formattedAddress: string, locationName: string): string {
    return (formattedAddress || '').replace(`${locationName} - `, '');
  }
}
